import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import hosts from './common/hosts';
/**
 * 会根据不同参数，生成不同的API接口
 * 使用：
 * const api=Serices.createApi();
 * api.getCountryList().then((data) => {
 *   console.log('APIExplore == getCountryList', data);
 *  });
 */
function getAlias() {
  if (window.baseAxios) {
    return window.baseAxios.alias;
  } else {
    return 'liveme';
  }
}
var Services = {
  /**
   * 获取Api APIExplore 接口
   */
  createApi: function createApi() {
    return new window.APIExplore(window.KEWLHttp, _objectSpread({}, hosts.getBase()), getAlias());
  }
};
export default Services;